"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = clamp;
exports.safeJsonParse = safeJsonParse;
function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
function safeJsonParse(raw, fallback) {
    try {
        return JSON.parse(raw);
    }
    catch {
        return fallback;
    }
}
